export default "/048cb1f2b29308e18768c65cfd51e426596a830c/680273bf09bfd3a8fc34474ae0d0eb37.svg";